import { ArrowUp, ArrowLeft, ArrowRight, CornerUpLeft, CornerUpRight, RotateCw, Flag, Navigation } from "lucide-react";
import { fmtKm, fmtDur } from "@/lib/api";
import { t, locale } from "@/i18n";
import { instructionText } from "@/i18n/instructions";

const icon = (s) => {
  if (!s) return Navigation;
  if (s.type === "arrive") return Flag;
  if (["roundabout", "rotary"].includes(s.type)) return RotateCw;
  const m = s.modifier || "";
  if (m.includes("sharp left") || m === "left") return CornerUpLeft;
  if (m.includes("sharp right") || m === "right") return CornerUpRight;
  if (m.includes("left")) return ArrowLeft;
  if (m.includes("right")) return ArrowRight;
  return ArrowUp;
};

export const NavInstruction = ({ step, distToStep, remainingM, remainingS }) => {
  const Icon = icon(step);
  const eta = new Date(Date.now() + remainingS * 1000).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" });
  return (
    <div className="flex items-stretch gap-0 rounded-2xl overflow-hidden shadow-2xl border border-[#243047]" data-testid="nav-instruction">
      <div className="bg-[#4accff] text-[#0b0f17] px-4 py-3 flex flex-col items-center justify-center min-w-[110px]">
        <Icon className="h-12 w-12" strokeWidth={3} />
        <span className="font-display text-2xl font-extrabold" data-testid="nav-step-distance">{fmtKm(distToStep)}</span>
      </div>
      <div className="bg-[#0b0f17]/95 backdrop-blur-xl px-4 py-3 flex-1 min-w-0">
        <p className="font-display text-2xl sm:text-3xl font-extrabold leading-tight truncate" data-testid="nav-step-text">{instructionText(step)}</p>
        <p className="text-slate-300 mt-1 text-base">
          {t("Arrivo")} <b className="text-white font-mono" data-testid="nav-eta">{eta}</b> · <b className="text-white font-mono">{fmtKm(remainingM)}</b> · {fmtDur(remainingS)}
        </p>
      </div>
    </div>
  );
};
